<template lang="pug">
li(:class="{'is-open': open }")
  span(:class="{ 'is-active': isFirstleafForCurrentPage }")
    a(v-if="isFirstleafForCurrentPage" id="currentTocItem")
    span(v-if="hasChildren" @click="toggle")
      a.fa.fa-fw.fa-minus-square-o.has-text-grey-light(v-if="open" title="weniger zeigen")
      a.fa.fa-fw.fa-plus-square-o(v-else title="mehr zeigen")
      span(v-html="$options.filters.formatStrikethrough(model.title)")
    span(v-else-if="isAvailable" @click="route")
      a(v-html="$options.filters.formatStrikethrough(model.title)")
    span.not-available(v-else v-html="$options.filters.formatStrikethrough(model.title)")
  ul(v-show="open" v-if="hasChildren")
    navigable-toc-item(class="item" v-for="(child, index) in contents" :key="[type, anchor, index].join('-')" :model="child" :parent="thisItem"
      :isNavigable="true" :level="level + 1")
</template>

<script>
import TocItem from "../../mixins/TocItem";

export default {
    name: "NavigableTocItem",
    mixins: [TocItem]
}
</script>